import { render } from "./Detail.vue?vue&type=template&id=2f4de2e6&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=2f4de2e6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2f4de2e6"

export default script